import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./assets/styles/main.css";
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (from.name == 'infos' && to.name == 'board') {
    sessionStorage.setItem('jump', '1')
    next()
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
